import React, { useEffect, useState } from "react";
import { Spinner, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import ReuseableTable from "components/Tables/ReuseableTable";
import { fetchContestDetails } from "store/actions/sportContestAction";

const column = ["Fan Id", "Name", "Gender", "Email"];

const keyMaps = {
  "Fan Id": "fanID",
  Name: "name",
  Gender: "gender",
  Email: "email",
};

const ContestFans = ({ contestId }) => {
  const dispatch = useDispatch();
  let { contestDetails } = useSelector((state) => state.contest);
  const updatedContestDetails = contestDetails.data.map((contest) => {
    const { fanID, gender, name, email } = contest?.userData || {};
    return { ...contest, fanID, gender, name, email };
  });

  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLoadMore = () => {
    setIsLoading(true);
    dispatch(
      fetchContestDetails({
        collectionName: "contest_enrollment",
        contestId,
        contestKey: "contest_id",
        userKey: "fan_id",
        lastVisible: contestDetails?.lastVisible,
      })
    ).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    setIsFetching(true);
    dispatch(
      fetchContestDetails({
        collectionName: "contest_enrollment",
        contestId,
        contestKey: "contest_id",
        userKey: "fan_id",
      })
    ).finally(() => setIsFetching(false));
  }, []);

  return (
    <div className="p-0">
      {isFetching ? (
        <div className="text-center py-4 text-primary">
          <Spinner animation="border" size="md" />
        </div>
      ) : (
        <>
          <ReuseableTable
            columns={column}
            keyMap={keyMaps}
            data={updatedContestDetails}
          />
          {contestDetails?.hasMore && (
            <div className="text-center py-2">
              <Button
                color="primary"
                onClick={handleLoadMore}
                disabled={isFetching || isLoading}
              >
                {isLoading ? <Spinner size="sm" /> : "Load More"}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ContestFans;
